
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Popup, Dialog } from 'vant';
import { isWeiXin } from '@/common/ts/common';

Vue.use(Popup, Dialog);

@Component
export default class OpenAppTip extends Vue {
  pointOut: boolean = false;
  trigger() {
    this.$dialog
      .confirm({
        title: '友情提示',
        message: '请在上游App参加活动',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        overlay: true,
        closeOnClickOverlay: true,
      })
      .then(() => {
        window.location.href =
          'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
      })
      .catch((action) => {
        // 微信提示用浏览器打开
        if (isWeiXin()) {
          console.log('微信提示');
          this.pointOut = true;
          return;
        }
        if (action !== 'overlay') {
          window.location.href =
            'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
        }
      });
  }
}
